import { Form, Input, Button, Select } from "antd";
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { createProject } from "@/api/project/project";
import TnMessage from "@/commons/widget/message";
import ConfirmModal from "@/commons/widget/monix-modal";
import './index.less'
import { ProjectType, ProjectTypeList } from "@/commons/enums/project-type";

interface IProps {
    showModal: boolean
    setShowModal: (v: boolean) => void
    onSuccess: () => void
}

export default function CreateProjectModal(props: IProps) {
    const [form] = Form.useForm();
    const btnRef = useRef(null);
    const [loading, setLoading] = useState<boolean>(false); // 添加的loading，防止重复添加

    // 初始化项目类型
    useEffect(() => {
        if (props.showModal) {
            form.setFieldsValue({
                projectType: ProjectType.BUILDING, // 默认楼栋
            });
        }
    }, [props.showModal]);

    const onCreateProject = () => {
        if (loading) return;
        if (btnRef.current) {
            btnRef.current.click();
        }
    }

    const onFinish = (value) => {
        value = {
            ...value,
            startTime: dayjs(value.startTime).valueOf()
        }
        setLoading(true)
        createProject(value).then(res => {
            if (res.status === 200) {
                // generateData();
                TnMessage.success("创建成功");
                // setShowModal(false);
                props.onSuccess();
            }
        }).catch(err => {
            TnMessage.error(err?.data || "创建失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <ConfirmModal
            title={"创建项目"}
            visible={props.showModal}
            setVisible={(e) => props.setShowModal(e)}
            onSaveClick={onCreateProject}
            wrapClassName="create-project-modal"
            saveDisable={loading}
        >
            <div className="create-project-body">
                <Form
                    colon={false}
                    form={form}
                    autoComplete="off"
                    labelCol={{ span: 5 }}
                    onFinish={onFinish}
                >
                    <Form.Item label="项目名称:" name="name" rules={[{ required: true, message: '项目名称不能为空' }]} >
                        <Input autoFocus />
                    </Form.Item>
                    <Form.Item label="项目类型:" name="projectType" rules={[{ required: true, message: '项目类型不能为空' }]} >
                        <Select options={ProjectTypeList} />
                    </Form.Item>
                    <Button loading={loading} ref={btnRef} htmlType="submit" style={{ display: 'none' }}></Button>
                </Form>
            </div>
        </ConfirmModal>
    )
}